import { BTable } from "bootstrap-vue";

export default {
  name: "BonExpireDay",

  components: {
    BTable,
  },

  data() {
    return {
      disabled: false,

      url: "admin/customers_club/get_is_bon_expire_day",

      editUrl: "admin/customers_club/set_is_bon_expire_day",

      items: [],

      customers_club_is_bon_expire_day: null,
    };
  },

  computed: {
    isValid() {
      const v = this.customers_club_is_bon_expire_day;
      return Number.isInteger(v) && v > 0;
    },
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.disabled = true;

      await this.$axios
        .get(this.url)
        .then((res) => {
          this.items = res.data.data.customers_club_is_bon_expire_day;

          // مقدار از سرور ممکنه رشته باشه، پس به عدد تبدیل می‌کنیم
          this.customers_club_is_bon_expire_day = Number(this.items.value);
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },

    async submitChanges() {
      if (!this.isValid) return;

      this.disabled = true;

      await this.$axios
        .put(this.editUrl, {
          customers_club_is_bon_expire_day: this
            .customers_club_is_bon_expire_day,
        })
        .then((res) => {
          this.$root.notify(res.data.message, "success");
          this.loadData();
        })
        .catch((err) => {
          this.$root.notify(err);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
  },
};
